import { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'

import type { QuestionAnswerOption } from '@healthblocks-io/core'

type MultiSelectCommentAnswerProps = {
  title: string
  description: string
  answerOptions: QuestionAnswerOption[]
  value: unknown
}

export const MultiSelectCommentAnswer = ({
  title,
  description,
  answerOptions,
  value,
}: MultiSelectCommentAnswerProps) => {
  const theme = useTheme()

  const items = Array.isArray(value) ? value : []

  const mappedAnswers = items.map((item) => {
    const itemValue = typeof item === 'string' ? item : item?.value
    const label = answerOptions.find((o) => o.value === itemValue)?.label
    const comment = typeof item === 'object' && item?.comment?.trim() ? item.comment.trim() : undefined
    const displayLabel = label ?? itemValue ?? ''
    return comment ? `${displayLabel} (${comment})` : displayLabel
  })

  return (
    <FlexColumn gap={theme.UI.Spacing.Space2}>
      <Span type='BodyMediumBold' color={theme.Colors.Neutrals.Darkest}>
        {`${title && description ? `${title}: ` : title || ''}${description}`}
      </Span>
      <ul style={{ listStyle: 'initial', paddingLeft: theme.UI.Spacing.Space4 }}>
        {mappedAnswers.map((item, index) => (
          <li key={index} style={{ color: theme.Colors.Neutrals.Darker }}>
            {item}
          </li>
        ))}
      </ul>
    </FlexColumn>
  )
}
